import { useMemo } from 'react'
import Search from 'features/ContractDetails/Facilities/HSTable/Search/Search'
import { Table } from 'components/Table'
import { isTableHasParams } from 'helper/common'
import { IContractHealthSystemWithHospitals } from 'features/ContractDetails/Facilities/types'
import { Props } from './types'
import './styles.scss'
import { ReactComponent as ArrowDown16 } from '../../../../assets/svg/ArrowDown16.svg'
import { ReactComponent as ArrowRight16 } from '../../../../assets/svg/ArrowRight16.svg'
import { useContractDetailsContext } from '../../Providers/ContractDetailsContextProvider'

export const HSTable = ({
  columns,
  tableData,
  searchValue,
  firstLoad,
  totalNumber,
  pageInfo,
  debouncedSearch,
  handleTableChange,
  handleChangePageSize,
  setSearchValue,
  expandedRowKeys,
  setExpandedRowKeys
}: Props) => {
  const {
    state: { isOnboarded, canSeeHealthSystem }
  } = useContractDetailsContext()

  const displayData = useMemo(
    () =>
      canSeeHealthSystem
        ? tableData
        : tableData.flatMap((hs) =>
            (hs.children ?? []).map((hospital) => ({
              ...hospital,
              key: hospital.uuid
            }))
          ),
    [canSeeHealthSystem, tableData]
  )

  return (
    <div className="table-wrapper hs-list">
      <div className="table-wrapper__header">
        <Search value={searchValue} onChange={setSearchValue} />
      </div>
      {!firstLoad && (
        <Table<IContractHealthSystemWithHospitals>
          scroll={{ scrollToFirstRowOnChange: true, x: 'max-content' }}
          dataSource={displayData}
          rowClassName={(record) => {
            if (!record.hospital_level && record.not_completed)
              return `warning-highlight ${isOnboarded ? 'onboarded' : ''}`
            if (
              record.hospital_level &&
              record.not_completed &&
              !record.amendment_document &&
              !record.hs_amendment_document
            )
              return `warning-highlight ${isOnboarded ? 'onboarded' : ''}`
            return ''
          }}
          className="contacts-hs-list-table expandable-lop-table"
          columns={columns}
          onChange={handleTableChange}
          hasSearchOrFilters={isTableHasParams(debouncedSearch, false)}
          onChangePage={handleChangePageSize}
          pageSize={pageInfo.pageSize}
          pagination={{
            pageSize: pageInfo.pageSize,
            current: pageInfo.pageNumber,
            total: totalNumber
          }}
          expandable={
            canSeeHealthSystem
              ? {
                  defaultExpandAllRows: false,
                  columnWidth: 40,
                  expandedRowKeys,
                  onExpand: (expanded, record) => {
                    if (expanded) setExpandedRowKeys([record.uuid])
                    else setExpandedRowKeys([])
                  },
                  expandIcon: ({ expanded, onExpand, record, expandable }) =>
                    expandable && !!record.children?.length ? (
                      expanded ? (
                        <div
                          className="expand-wrapper row gap-12 align-center"
                          onClick={(e) => onExpand(record, e)}
                        >
                          <ArrowDown16 className="arrow" />
                        </div>
                      ) : (
                        <div
                          className="expand-wrapper row gap-12 align-center"
                          onClick={(e) => onExpand(record, e)}
                        >
                          <ArrowRight16 className="arrow" />
                        </div>
                      )
                    ) : (
                      <div style={{ width: isOnboarded ? 32 : 0 }} />
                    )
                }
              : undefined
          }
        />
      )}
    </div>
  )
}
